import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import AdminLayout from "../components/feature/AdminLayout";
import ProtectedRoute from "../components/feature/ProtectedRoute";
import CatalogPage from "../pages/catalog/page";
import ProductFormPage from "../pages/catalog/ProductFormPage";
import OrdersPage from "../pages/orders/page";
import RequestsPage from "../pages/requests/page";
import AnalyticsPage from "../pages/analytics/page";
import LoginPage from "../pages/auth/page";
import UsersPage from "../pages/users/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute section="catalog">
        <AdminLayout>
          <CatalogPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/catalog",
    element: (
      <ProtectedRoute section="catalog">
        <AdminLayout>
          <CatalogPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/catalog/new",
    element: (
      <ProtectedRoute section="catalog">
        <AdminLayout>
          <ProductFormPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/catalog/:id",
    element: (
      <ProtectedRoute section="catalog">
        <AdminLayout>
          <ProductFormPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/orders",
    element: (
      <ProtectedRoute section="orders">
        <AdminLayout>
          <OrdersPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/requests",
    element: (
      <ProtectedRoute section="requests">
        <AdminLayout>
          <RequestsPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/analytics",
    element: (
      <ProtectedRoute section="analytics">
        <AdminLayout>
          <AnalyticsPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/users",
    element: (
      <ProtectedRoute section="users">
        <AdminLayout>
          <UsersPage />
        </AdminLayout>
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
